import { z } from "zod";
import { createOverleveringChecklistRows } from "../901-overlevering/901InitialData.js";
import {
  ZOverleveringChecklistQuestionRow,
  ZOverleveringChecklistSectionRow,
  type OverleveringChecklistRowDef,
} from "../901-overlevering/901Schema.js";

export const ZNivaa1Assessment = z.enum(["RED", "YELLOW", "LIGHT_GREEN", "DARK_GREEN", "BLUE", "GRAY"]);
export type INivaa1Assessment = z.infer<typeof ZNivaa1Assessment>;

const ZNivaa1QuestionRow = ZOverleveringChecklistQuestionRow.extend({
  assessment: ZNivaa1Assessment.nullable().default(null),
});

export const ZForenkletStyringNivaa1Report = z.object({
  startupChecklistType: z.literal("startup_checklist_forenklet_styring_nivaa_1"),
  rows: z.array(z.discriminatedUnion("kind", [ZOverleveringChecklistSectionRow, ZNivaa1QuestionRow])),
});

export type IForenkletStyringNivaa1Report = z.infer<typeof ZForenkletStyringNivaa1Report>;

export const FORENKLET_STYRING_NIVAA_1_ROW_DEFS: OverleveringChecklistRowDef[] = [
  { nr: "1", text: "Kravgjennomgang", kind: "SECTION" },
  {
    nr: "1.1",
    text: "Er avtale/ordrebekreftelse signert, eller avrop på rammeavtale bekreftet i e-post, tagget og arkivert i mappe 01 Startprodukt? Se lenke til [Veiledning for tagging av signerte avtaledokumenter](https://livelink.multiconsult.no/ll/livelink.exe?func=ll&objaction=overview&objid=51466235).",
    kind: "QUESTION",
    questionId: "902-q001",
  },
  {
    nr: "1.2",
    text: "Er det uklare krav/forutsetninger i avtaledokumenter/andre grunnlagsdokumenter som må avklares internt eller med kunden?",
    kind: "QUESTION",
    questionId: "902-q002",
  },
  {
    nr: "1.3",
    text: "Er kundens behov og forventninger avklart, og er omfang av leveranse/sluttprodukt avtalt og kommunisert i oppdaget?",
    kind: "QUESTION",
    questionId: "902-q003",
  },
  { nr: "2", text: "Risikovurdering", kind: "SECTION" },
  {
    nr: "2.1",
    text: 'Kan våre våre leveranser bli brukt av en totalentreprenør til å gi bindende pris? (høy risiko). Se beskrivelse av håndtering av totalentreprisekontrakter under pkt. 4.1.2 i prosedyre [Salg i Multiconsult - Avtalehåndtering](https://livelink.multiconsult.no/ll/livelink.exe?func=ll&objId=62523452&objAction=download), og veiledning bak "rød trekant" i denne cellen.',
    kind: "QUESTION",
    questionId: "902-q004",
  },
  {
    nr: "2.2",
    text: "Kan det bli habilitets-/rollekonflikt for medarbeidere i oppdraget?",
    kind: "QUESTION",
    questionId: "902-q005",
  },
  { nr: "2.3", text: "Er kunden kjent og økonomisk solid?", kind: "QUESTION", questionId: "902-q006" },
  {
    nr: "2.4",
    text: "Har OL og oppdragsmedarbeiderne riktig kompetanse for oppdraget?",
    kind: "QUESTION",
    questionId: "902-q007",
  },
  { nr: "3", text: "Kvalitetsplanlegging", kind: "SECTION" },
  { nr: "3.1", text: "Er det aktuelt med SJA i oppdraget?", kind: "QUESTION", questionId: "902-q008" },
  {
    nr: "3.2",
    text: "Kan vårt arbeid medføre risiko-forhold som vil kreve spesifikke SHA-tiltak på bygge- / anleggsplassen / i driftsfasen, eller som kan medføre negative miljøkonsekvenser?",
    kind: "QUESTION",
    questionId: "902-q009",
  },
  { nr: "3.3", text: "Er sjekkliste for faglig kontroll identifisert?", kind: "QUESTION", questionId: "902-q010" },
  { nr: "3.4", text: "Er sidemannskontrollør og FLO utpekt?", kind: "QUESTION", questionId: "902-q011" },
  {
    nr: "3.5",
    text: "Er fremdrift og leveransetidspunkt avtalt med kunde, oppdragsmedarbeidere og sidemannskontrollør (er)?",
    kind: "QUESTION",
    questionId: "902-q012",
  },
  { nr: "3.6", text: "Er oppstartmøte planlagt/ gjennomført?", kind: "QUESTION", questionId: "902-q013" },
];

export const FORENKLET_STYRING_NIVAA_1_INIT_DATA: IForenkletStyringNivaa1Report = {
  startupChecklistType: "startup_checklist_forenklet_styring_nivaa_1",
  rows: createOverleveringChecklistRows(FORENKLET_STYRING_NIVAA_1_ROW_DEFS).map((row) =>
    row.kind === "QUESTION" ? { ...row, assessment: null } : row,
  ),
};
